import { formatRelativeTime as a } from "../helper/format.js";
import t from "i18next";
import * as s from "ramda";
import { initReactI18next as i } from "react-i18next";
const c = {
  common: {
    all: "All",
    button: {
      back: "Back",
      bind: "Bind",
      buy: "Buy",
      change: "Change",
      claim: "Claim",
      claim_all: "Claim All",
      clear_all: "Clear All",
      confirm: "Confirm",
      connect: "Connect",
      copied: "Copied",
      copy: "Copy",
      delete: "Delete",
      detail: "Detail",
      done: "Done",
      download: "Download",
      edit: "Edit",
      end: "End",
      filter: "Filter",
      gift: "Gift",
      goto_inventory: "GO TO INVENTORY",
      long: "Long",
      morph_to_adult: "Morph To Planet",
      new: "New",
      next: "Next",
      ok: "OK",
      ordering_bottom: "Bottom",
      ordering_down: "Down",
      ordering_jump: "Jump",
      ordering_top: "Top",
      ordering_up: "Up",
      previous: "Previous",
      remove: "Remove",
      renew: "Renew",
      save: "Save",
      sell: "Sell",
      short: "Short",
      sign: "Sign",
      submit: "Submit",
      yes: "Yes"
    },
    buyer: "Buyer",
    congraz: "CONGRATULATIONS!",
    date: {
      time: "{{ count , #fromNow }}",
      time_ago: "{{ count , #fromNow }} ago"
    },
    days: "Days",
    detail: {
      share: {
        copy_link: "Copy link",
        copy_message: "Wallet Address has been copied to the clipboard",
        facebook: "Share on Facebook",
        twitter: "Share on X"
      }
    },
    empty_list: "Sorry, you don't have any item on this list",
    error: "Error: {{errorMessage}}",
    foonie_magus: "Foonie Magus",
    go: "Go",
    grid: {
      address: "Address",
      email: "Email",
      name: "Name"
    },
    i18n_format: {
      day: "{{count}} day",
      day_other: "{{count}} days",
      hour: "{{count}} hour",
      hour_other: "{{count}} hours",
      hour_short: "{{count}} hr",
      hour_short_other: "{{count}} hrs",
      just_now: "just now",
      minute: "{{ count }} minute",
      minute_other: "{{ count }} minutes",
      minute_short: "{{ count }} min",
      minute_short_other: "{{ count }} mins",
      month: "{{ count }} month",
      month_other: "{{ count }} months",
      month_short: "{{ count }} month",
      month_short_other: "{{ count }} months",
      second: "{{ count }} second",
      second_other: "{{ count }} seconds",
      second_short: "{{ count }} sec",
      second_short_other: "{{ count }} secs",
      year: "{{ count }} year",
      year_other: "{{ count }} years",
      year_short: "{{ count }} yr",
      year_short_other: "{{ count }} yrs"
    },
    keyword: {
      planet_owner: "Planet Owner",
      star_owner: "Star Owner"
    },
    logic: {
      no_internet: "It appears you are offline"
    },
    multi_selected: "Selected x {{ count }}",
    no_balance: "You do not have enough balance",
    no_data: "No record",
    not_applicable: "N/A",
    others: "Others",
    page: {
      no_access: "Please login to access this page",
      not_found: `We are sorry, 
the page you requested cannot be found.`
    },
    popup: {
      confirm_remove: "Confirm removal?",
      got_it: "Got It",
      no_close_browser: "Please <strong>DO NOT</strong> close your browser.",
      remove: "Remove",
      transaction: {
        be_patient: "Submitting transaction to Network. Please be patient...",
        check_approval: "Checking for approval...",
        wait_approval: "Waiting for approval..."
      }
    },
    second_ago: "{{ count }} second ago",
    second_ago_other: "{{ count }} seconds ago",
    select_exceed_limit: `<strong>SORRY</strong>
You can only select up to <strong>{{count}}</strong> item`,
    select_exceed_limit_other: `<strong>SORRY</strong>
You can only select up to <strong>{{count}}</strong> items`,
    selected: "Selected",
    seller: "Seller",
    title: {
      about: "About",
      sale_history: "Sale History"
    },
    tooltip: {
      disable_buy: "Please login to complete this purchase",
      required_ronin: "This operation is disabled when not on the Ronin network"
    },
    total: "Total",
    you: "You"
  }
}, d = () => {
  const n = {
    lng: "en-us",
    lowerCaseLng: !0,
    resources: {
      "en-us": {
        translation: c
      }
    },
    interpolation: {
      escapeValue: !1,
      format: (o, r) => {
        const e = a(o, r);
        return s.isNil(e) ? o : e;
      }
    }
  };
  t.use(i).init(n);
}, h = t;
export {
  h as default,
  d as mockI18N
};
//# sourceMappingURL=index.js.map
